module.exports = __webpack_public_path__ + "img/logout.11b979af.svg";